import React, { useState, useEffect } from "react";
import { collection, addDoc, doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import Cierre from "../../Cierre";
import { useAuth } from "../../context/authContext";
import { useNavigate } from 'react-router-dom';
import { app } from "../../firebase";

function Form2() {
  const cierre = Cierre()
  const navigate = useNavigate();
  const timestamp = new Date();
  const formattedDat = timestamp.toISOString();
  const formattedDate = timestamp.toISOString().split("T")[0];
  const { user } = useAuth();

  const [archivoSeleccionado, setArchivoSeleccionado] = useState(null);
  const [mensaje, setMensaje] = useState(
    "Por favor, seleccione un archivo comprimido con la información necesaria, luego presione enviar"
  );
  const [porcentajeCarga, setPorcentajeCarga] = useState(0); 
  const [textoBoton, setTextoBoton] = useState('Enviar Archivo');

  const handleClick = () => {
    setTextoBoton('Espere porfavor...');
  };

  const onFileChange = (e) => {
    const nombreArchivo = e.target.files[0].name;
    setArchivoSeleccionado(e.target.files[0]);
    if (nombreArchivo) {
      setMensaje("Subirá el archivo "+ nombreArchivo + ", por favor presione Enviar Archivo.");
    } else {
      setMensaje(
        "Por favor, seleccione un archivo comprimido con la información necesaria"
      );
    }
  };

  const onEnviar = async (e) => {
    e.preventDefault();
    if (archivoSeleccionado) {
      const storageRef = app.storage().ref();
      const carpetaRef = storageRef.child(user.displayName + "/te1-convencional");
      const archivoPath = carpetaRef.child(archivoSeleccionado.name);
      setPorcentajeCarga(1);
      try {
        await archivoPath.put(archivoSeleccionado);
        console.log("Archivo cargado:", archivoSeleccionado.name);

        const uploadTask = archivoPath.put(archivoSeleccionado);

      uploadTask.on('state_changed', 
        (snapshot) => {
          // Manejar el progreso de la carga
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log('Progreso de carga: ' + progress + '%');
          setPorcentajeCarga(progress); // Actualizar el estado del porcentaje de carga
          setMensaje(Math.round(progress,1)+"%")
        }, 
        (error) => {
          // Manejar errores durante la carga
          console.error('Error al cargar el archivo:', error);
          // Puedes establecer un mensaje de error si es necesario
          setMensaje('Hubo un error al cargar el archivo. Por favor, inténtalo de nuevo.');
        }, 
        () => {
          
          // Manejar la carga completada con éxito
          // Esto se ejecuta cuando la carga se completa
          console.log('Carga completa');
          // Puedes establecer un mensaje de éxito si es necesario
          setMensaje('¡Archivo cargado exitosamente!');
          //navigate('cierre');
          window.location.assign(
            "https://drawingsmachines.com/pasarela21.html"
          );
       
        

        }
        );

        const enlaceUrl2 = await archivoPath.getDownloadURL();
        console.log(enlaceUrl2);
        setArchivoSeleccionado({
          ...archivoSeleccionado,
          enlaceUrl2: enlaceUrl2,
        });
        // Establecer el mensaje de éxito
        setMensaje('Cargando archivo..');

      } catch (error) {
        console.error('Error al cargar el archivo:', error);
        // Puedes establecer un mensaje de error si es necesario
        setMensaje('Hubo un error al cargar el archivo. Por favor, inténtalo de nuevo.');
      }
    }
  };


  return (
    <div
      id="contenedor-principal"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <div
        id="contenedor-formulario"
        style={{
          width: "500px",
          background: "white",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <h2 className="text-2xl mb-4 text-align: center">
          Confección TE1 Convencional
        </h2>
        <form onSubmit={onEnviar}>
          <div className="flex flex-row items-center mb-4">
            <input
              type="file"
              onChange={onFileChange}
              style={{ display: "none" }}
              id="subir-archivo"
            />
            <label
              htmlFor="subir-archivo"
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded cursor-pointer"
            >
              Seleccionar Archivo
            </label>
          </div>
          <div className="flex flex-row justify-between mt-4 w-full">
            <span id="nombre-archivo">{mensaje}</span>
            <button
              type="submit"
              className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
              onClick={handleClick}>{textoBoton}
              
            </button>
            <button
              type="reset"
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
            >
              Reiniciar
            </button>
          </div>
          
        </form>
      </div>
    </div>
  );
}

export default Form2;
